
<template>
  <nav class="app-menu">
    <ul class="app-menu-list" v-if="menus">
      <li v-for="(item, index) in menus" :key="item.path" class="app-menu-item">
        <!-- 含2级菜单 -->
        <template v-if="item.children">
          <div class="first-menu" @click="handleFold(index)">
            <svg-icon :icon-class="item.icon" />
            <span class="first-menu-title">{{ item.title }}</span>
            <i v-if="item.children" class="fold-icon el-icon-arrow-up" :class="item.fold ? 'fold-rotate' : ''"></i>
          </div>
          <ul v-if="item.children" class="sub-menu" :class="item.fold ? 'fold-sub-menu' : ''">
            <template v-for="i in item.children">
              <li
                v-if="!i.hidden"
                :key="i.path"
                class="sub-menu-item"
                :class="current === i.path ? 'current-menu' : ''"
              >
                <router-link v-if="!isBigScreen(i.path)" :to="resolvePath(item.path, i.path)">
                  <el-tooltip
                    v-if="i.title && getStrLen(i.title) > 8"
                    effect="dark"
                    :content="i.title"
                    placement="bottom"
                  >
                    <span class="line-ellipsis sub-menu-title">{{ i.title }}</span>
                  </el-tooltip>
                  <span v-else class="sub-menu-title">{{ i.title }}</span>
                </router-link>
                <span v-else class="sub-menu-title" @click="clickRouter(i.path)">{{ i.title }}</span>
              </li>
            </template>
          </ul>
        </template>
        <!-- 仅1级菜单 -->
        <template v-else>
          <router-link
            v-if="!isBigScreen(item.path)"
            class="first-menu"
            :class="current === item.path ? 'current-menu' : ''"
            :to="resolvePath(item.path, '')"
            :underline="false"
          >
            <svg-icon :icon-class="item.icon" />
            <span class="first-menu-title">{{ item.title }}</span>
          </router-link>
          <div
            v-else
            class="first-menu"
            :class="current === item.path ? 'current-menu' : ''"
            @click="clickRouter(item.path)"
          >
            <svg-icon :icon-class="item.icon" />
            <span class="first-menu-title">{{ item.title }}</span>
          </div>
        </template>
      </li>
    </ul>
  </nav>
</template>

<script>
// Node path.resolve replacement for browser (webpack 5 no longer polyfills Node builtins)
const resolvePath = (basePath, routePath) => {
  if (!routePath) return basePath;
  if (/^https?:\/\//.test(routePath)) return routePath;
  if (routePath.startsWith('/')) return routePath;
  const base = basePath.replace(/\/+$/, '');
  return base + '/' + routePath.replace(/^\/+/, '');
};

import store from '@/store';
import { isExternal } from '@/utils/validate';
import { getToken } from '@/utils/auth';

export default {
  name: 'AppMenu',
  data() {
    return {
      menus: null
    };
  },
  computed: {
    current() {
      return this.$route.path;
    }
  },
  mounted() {
    this.menus = this.handleSortMenu(store.getters.menus);
    this.expandCurrentMenu();
  },
  methods: {
    isBigScreen(path) {
      return Boolean(path && path.indexOf('bigScreen') !== -1);
    },
    clickRouter(path) {
      // 大屏类菜单在新标签页打开，当前标签页不跳转
      if (this.isBigScreen(path)) {
        const token = getToken();
        const url = path + '?token=' + (token || '');
        window.open(url, '_blank');
      }
    },
    getStrLen(str) {
      if (!str) return 0;
      // 中文字符算2，其他算1
      return str.replace(/[^\x00-\xff]/g, 'aa').length;
    },
    handleSortMenu(data) {
      return data.map((item) => {
        const { menuName, shortName, menuIcon, frontendUrl, isShow, children } = item;
        const title = shortName || menuName;
        const newChildren = children ? this.handleSortMenu(children) : null;
        const path = frontendUrl.startsWith('/') ? frontendUrl : '/' + frontendUrl;
        return {
          children: newChildren,
          title,
          icon: menuIcon,
          fold: true,
          path,
          hidden: !Boolean(isShow == '1')
        };
      });
    },
    // 折叠菜单
    handleFold(index) {
      this.menus[index]['fold'] = !this.menus[index]['fold'];
    },
    // 根据当前路由展开对应的一级菜单
    expandCurrentMenu() {
      const currentPath = this.current;
      this.menus.forEach((menu, index) => {
        if (!menu.children || !menu.path || menu.path === '/') return;
        if (currentPath === menu.path || currentPath.startsWith(menu.path + '/')) {
          this.$set(this.menus[index], 'fold', false);
        }
      });
    },
    resolvePath(basePath, routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(basePath)) {
        return basePath;
      }
      return resolvePath(basePath, routePath);
    }
  }
};
</script>

<style lang="scss" scoped>
.app-menu {
  @include scrollBar;

  width: $-menu-width;
  height: 100%;
  flex-shrink: 0;
  background-color: $--color-white;
  border-radius: $--border-radius-base;
  font-size: $--font-size-base;
  overflow-y: overlay;

  .app-menu-list {
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 25px;
  }

  .first-menu {
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;
    color: $--color-text-primary;
    font-weight: 500;

    &:hover {
      color: $--color-primary;
    }
    .first-menu-title {
      padding-left: 4px;
      flex: 1;
      padding-right: auto;
      font-size: $--font-size-base;
    }
    .fold-icon {
      transition: all 0.3s;
      &.fold-rotate {
        transform: rotate(180deg);
      }
    }
  }

  .sub-menu {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    transition: all 0.3s;
    transition: max-height 0.3s;
    overflow: hidden;
    padding-top: 20px;
    max-height: 500px;
    row-gap: 20px;
    .sub-menu-item {
      width: 50%;
      color: #505257;
      .sub-menu-title {
        display: block;
        max-width: 65px;
        font-size: 13px;
        word-break: break-all;
        white-space: normal;
        overflow-wrap: break-word;
        line-height: 1.4;
      }
      &:hover {
        color: $--color-primary;
        font-weight: 700;
      }
    }
    &.fold-sub-menu {
      max-height: 0;
    }
  }
  .current-menu {
    font-weight: 700;
    color: $--color-primary !important;
  }
}
</style>
